import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { MapStringTo, Object_Unknown } from "./base-types";
import Link from "./link";

@JsonObject()
export class EntityLink extends Link {
    @JsonProperty("properties")
    properties: MapStringTo<Object_Unknown>;

    @JsonProperty("renditions")
    renditions: MapStringTo<Object_Unknown>;

    @JsonProperty("permissions")
    @JsonElementType(String)
    permissions: Array<string>;

    @JsonProperty("identifier")
    identifier: string;
}
